import toasts from './toasts'
export default {
    toasts: toasts
}
